module.exports = __webpack_public_path__ + "img/orientation_Vertical.7cb0db83.svg";